export const vfocus = {
	mounted: el => {
		el.focus();
	}
};
